import React, { useEffect, useState } from "react";
import { Layers, Check, Clock } from "lucide-react";
import api from "../../lib/api";
import { PageHeader, Card, Badge, RedButton, GhostButton } from "../../components/crm/ui";
import { toast } from "sonner";

export default function Integrations() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  const load = () => api.get("/integrations").then(({ data }) => setItems(data.items)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async (key) => { await api.post(`/integrations/${key}/configure`, { note: "placeholder" }); toast.success("Configuration saved (not yet active)"); setOpen(null); load(); };

  return (
    <div>
      <PageHeader title="Integrations" subtitle="A modular framework. AllToMAIDIt owns acquisition & follow-up; connected systems own their records." />
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((i) => (
          <Card key={i.key} className="p-5" data-testid={`integration-${i.key}`}>
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-3"><div className="w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center"><Layers size={18} className="text-slate-500" /></div><div><h3 className="font-display font-bold text-slate-900">{i.name}</h3><p className="text-xs text-slate-500">{i.category}</p></div></div>
              {i.status === "available" ? <Badge tone="green">Available</Badge> : <Badge tone="amber"><Clock size={10} className="mr-1" />Coming Soon</Badge>}
            </div>
            <p className="text-sm text-slate-600 mt-3 min-h-[40px]">{i.description}</p>
            {i.key === "churchtrac" && <p className="text-xs text-slate-400 mt-2 italic">{i.note}</p>}
            <div className="mt-4">
              {i.connected ? <Badge tone="green"><Check size={11} className="mr-1" /> Connected</Badge> :
                <GhostButton className="w-full" onClick={() => setOpen(i)} data-testid={`configure-${i.key}`}>{i.status === "available" ? "Configure" : "Set up for later"}</GhostButton>}
            </div>
          </Card>
        ))}
      </div>

      {open && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" onClick={() => setOpen(null)}>
          <Card className="w-full max-w-md p-6" onClick={(e) => e.stopPropagation()}>
            <h2 className="font-display text-xl font-bold text-slate-900 mb-1">{open.name}</h2>
            <p className="text-sm text-slate-500 mb-4">{open.description}</p>
            {open.key === "churchtrac" && open.ownership && (
              <div className="bg-slate-50 rounded-lg p-4 mb-4 text-xs text-slate-600 space-y-2">
                {Object.entries(open.ownership).map(([k, v]) => <div key={k}><p className="font-semibold text-slate-800">{k}</p><p>{v.join(", ")}</p></div>)}
              </div>
            )}
            <p className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-md p-3 mb-4">This integration is not yet active. Saving stores placeholder configuration for future setup.</p>
            <div className="flex gap-3"><GhostButton className="flex-1" onClick={() => setOpen(null)}>Cancel</GhostButton><RedButton className="flex-1" onClick={() => save(open.key)} data-testid="integration-save">Save Configuration</RedButton></div>
          </Card>
        </div>
      )}
    </div>
  );
}
